
class AttributeType {
    static String = 'string';
    static Decimal = 'decimal';
}

export default AttributeType;